/**
 * The Modal jQuery plugin
 *
 * @author Alexander Makarov <sam@rmcreative.ru>
 * @link https://github.com/samdark/the-modal
 * @version 1.0
 */

;(function($, window, document, undefined) {
    "use strict";
    /*jshint smarttabs:true*/

    function scrollbarWidth() {
        var block = $('<div>').css({'height':'50px','width':'50px'}),
            indicator = $('<div>').css({'height':'200px'});
        $('body').append(block.append(indicator));
        var w1 = $('div', block).innerWidth();
        // block.css('overflow-y', 'scroll');
        var w2 = $('div', block).innerWidth();
        $(block).remove();
        return (w1 - w2);
    }


    var pluginNamespace = 'the-modal',
        // global defaults
        defaults = {
            overlayClass: 'themodal-overlay',

            closeOnEsc: true,
            closeOnOverlayClick: true,

            onClose: null,
            onOpen: null,

            cloning: false
        };


    function lockContainer(scrollBarW) {
        $('html,body').addClass('lock');
    }

    function unlockContainer() {
        $('html,body').removeClass('lock');
        $('html').css({'margin-right':'0'})
    }

    function verticalPos(el) {

        var wh = $(window).height();
        var eh = el.outerHeight();

        if(eh>(wh-40))el.css({'marginTop':'20px'});
        else{
            var top = (wh-eh)/2;
            el.css({'marginTop':top+'px'});
        }

    }

    function init(els, options) {
        var scrollBarW =  0;// scrollbarWidth();
        var modalOptions = options;

        if(els.length) {
            els.each(function(){
                $(this).data(pluginNamespace+'.options', modalOptions);
            });
        }
        else {
            $.extend(defaults, modalOptions);
        }

        return {
            open: function(options) {

                var el = els.get(0);
                $(el).css({'marginTop':0});
                var localOptions = $.extend({}, defaults, $(el).data(pluginNamespace+'.options'), options);

                // close modal if opened
                if($('.'+localOptions.overlayClass).length) {
                    $.modal().close();
                }



                var overlay = $('<div/>').addClass(localOptions.overlayClass).hide().prependTo('body');
                overlay.data(pluginNamespace+'.options', options);

                // lockContainer(scrollBarW);
                if(el) {
                    if($(window).height()<$(document).height()){
                        $('html').css({'margin-right':scrollBarW+'px'});
                        // overlay.css({'overflow-y':'scroll'});
                    }

                    if (!localOptions.cloning) {
                        overlay.data(pluginNamespace+'.el', el);
                        $(el).data(pluginNamespace+'.parent', $(el).parent());
                        $(el).appendTo(overlay).show();
                        overlay.show();
                        overlay.addClass('show');
                        setTimeout(function(){$(el).addClass('show')},50);
                        verticalPos($(el));
                        $(window).resize(function(){verticalPos($(el))});

                    } else {
                        verticalPos($(el));
                        var newel = $(el).clone(true);
                        newel.appendTo(overlay).show();
                        overlay.show();
                        overlay.addClass('show');
                        setTimeout(function(){newel.addClass('show')},50);
                        $(window).resize(function(){verticalPos(newel)});
                        newel.resize(function(){verticalPos(newel)});
                    }


                }

                if(localOptions.closeOnEsc) {
                    $(document).bind('keyup.'+pluginNamespace, function(e){
                        if(e.keyCode === 27) {
                            $.modal().close();
                        }
                    });
                }

                if(localOptions.closeOnOverlayClick) {
                    overlay.children().on('click.' + pluginNamespace, function(e){
                        e.stopPropagation();
                    });
                    $('.' + localOptions.overlayClass).on('click.' + pluginNamespace, function(e){
                        $.modal().close();
                    });
                }

                $(document).bind('touchmove.'+pluginNamespace,function(e){
                    if(!$(e).parents('.' + localOptions.overlayClass)) {
                        e.preventDefault();
                    }
                });

                if(localOptions.onOpen) {
                    localOptions.onOpen(overlay, localOptions);
                }
            },
            close: function() {
                var el = els.get(0);

                var localOptions = $.extend({}, defaults, options);
                var overlay = $('.' + localOptions.overlayClass);
                $.extend(localOptions, overlay.data(pluginNamespace+'.options'));

                if (!localOptions.cloning) {
                    if (!el) {
                        el = overlay.data(pluginNamespace+'.el');
                    }
                    $(el).removeClass('show');
                    setTimeout(function(){
                        $(el).hide().appendTo($(el).data(pluginNamespace+'.parent'));

                    },300)

                }


                overlay.removeClass('show');
                setTimeout(function(){
                    overlay.remove();
                    // unlockContainer();
                },300)
                // setTimeout('overlay.remove()',300);


                if(localOptions.closeOnEsc) {
                    $(document).unbind('keyup.'+pluginNamespace);
                }

                if(localOptions.onClose) {
                    localOptions.onClose(overlay, localOptions);
                }
                $(el).trigger('modalClose');
            },
            verticalPos : function(el){
                verticalPos(el);
            }
        };
    }

    $.modal = function(options){
        return init($(), options);
    };

    $.fn.modal = function(options) {
        return init(this, options);
    };

})(jQuery, window, document);


// WEBPACK FOOTER //
// ../htdocs/js/plugins/jquery.the-modal.js